<template>
  <div>
    <wc-page-title :title='title'>
        <template v-slot:rightSide>
        <div class='d-flex'>
            <wc-burger-menu menuIcon='mdi-menu'>  
            <v-list>

                <v-list-item @click='show_legend_dialog=true'>
                <v-list-item-icon>
                    <v-icon color='info'>mdi-format-list-text</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Project Row Legend</v-list-item-title>
                </v-list-item-content>
                </v-list-item>

                <v-list-item @click='show_conflicts_dialog=true'>
                <v-list-item-icon>
                    <v-icon color='warning'>mdi-alert-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Conflicts Legend</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
            </v-list>
            </wc-burger-menu>
        </div>
        </template>
    </wc-page-title>
    <staging-legend
        :show_legend_dialog='show_legend_dialog'
        @showLegendDialog='showLegendDialog'
    />
    <staging-conflicts
        :show_conflicts_dialog='show_conflicts_dialog'
        @showConflictsDialog='showConflictsDialog'
    />
  </div>

</template>

<script>
import Legend from '../dialog/Legend.vue';
import Conflicts from '../dialog/Conflicts.vue';

export default {
  name: 'staging-menu',
  props: {
    title: {
      required: false,
      type: String,
      default: 'Staging'
    }
  },
  data: () => ({
    show_legend_dialog: false,
    show_conflicts_dialog: false,
  }),
  methods: {
    showLegendDialog(bool){
        this.show_legend_dialog = bool;
    },
    showConflictsDialog(bool){
        this.show_conflicts_dialog = bool;
    }
  },
  components: {
    'staging-legend': Legend,
    'staging-conflicts': Conflicts
  }
}
</script>